import { appConfigMeta } from "./appConfig.js";
export const SERVER_ONLY_MAX_LENGTH = 5000;
const isSection = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
const isConfigField = (value) => isSection(value) && "value" in value;
const omitFields = (config, meta, isOmitted) => Object.fromEntries(Object.entries(config).flatMap(([key, value]) => {
    const entry = meta[key];
    if (isConfigField(entry))
        return isOmitted(entry) ? [] : [[key, value]];
    if (!isSection(entry) || !isSection(value))
        return [[key, value]];
    const nested = omitFields(value, entry, isOmitted);
    return Object.keys(nested).length > 0 ? [[key, nested]] : [];
}));
const filterConfigs = (isOmitted) => (config) => isSection(config)
    ? omitFields(config, appConfigMeta, isOmitted)
    : config;
/** Drops values the browser must not persist. They are still served when asked for. */
export const filterLocalStorageConfigs = filterConfigs((field) => field.localStorage === false);
/** Drops values that never leave the server unless an authorised admin asks for them. */
export const filterServerOnlyConfigs = filterConfigs((field) => field.serverOnly === true);
//# sourceMappingURL=filters.js.map